<template>
  <div>
    <b-card no-body>
      <b-tabs card>
        <b-tab active>
          <template slot="title">
            <tab-item icon="users" heading="Step 1" subheading="Details"></tab-item>
          </template>
          <div class="form-panel">
            <b-row>
              <b-col sm="3">
                <strong>Details</strong>
                <p>Enter the general details of this translational team here.</p>
              </b-col>
              <b-col sm="9">
                <b-form class="form-horizontal">
                  <b-form-group label="Transitional Team Name"
                                label-class="control-label"
                                :class="{ 'invalid-group': $v.form.name.$error }">
                    <b-form-input v-model="form.name" type="text" :class="{ 'is-invalid': $v.form.name.$error }"></b-form-input>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.name.$error">You must enter a name.</span>
                  </b-form-group>

                  <b-form-group label="Start Date"
                            label-class="control-label"
                            :class="{ 'invalid-group': $v.form.startDate.$error }">
                      <datepicker v-model="form.startDate"
                                  :inputClass="{ 'form-control': true }"
                                  typeable
                                  format="MM/dd/yyyy"></datepicker>
                      <span class="span-feedback invalid-feedback" v-if="$v.form.startDate.$error">Please enter a start date.</span>
                  </b-form-group>

                  <b-form-group label="End Date"
                                label-class="control-label"
                                :class="{ 'invalid-group': $v.form.endDate.$error }">
                      <datepicker v-model="form.endDate"
                                  :inputClass="{ 'form-control': true }"
                                  typeable
                                  format="MM/dd/yyyy"></datepicker>
                      <span class="span-feedback invalid-feedback" v-if="$v.form.endDate.$error">Please enter a start date.</span>
                  </b-form-group>

                  <b-form-group label="Associated Sites" label-class="control-label">
                  <autocomplete ref="siteAutocomplete"
                                :source="sitesApi"
                                placeholder="Search Sites"
                                :inputClass="{'form-control' : true}"
                                resultsValue="siteId"
                                resultsDisplay="name"
                                credentials="include"
                                :request-headers="requestHeaders"
                                clearAfterEntry
                                @selected="addSite"></autocomplete>

                  <div class="site-list-div" v-if="selectedSites.length">
                    <div class="site-list">
                      <div v-for="site in selectedSites" :key="site.siteId">
                        <b-badge variant="primary" class="site-badge" @click="removeSite(site)">
                          <font-awesome-icon icon="times" /> {{ site.name }}
                        </b-badge>
                      </div>
                    </div>
                  </div>

                </b-form-group>

                  <b-form-group label="Description" label-class="control-label">
                    <vue-editor id="descriptionEditor" v-model="form.description"></vue-editor>
                  </b-form-group>
                </b-form>
              </b-col>
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-button class="btn-primary pull-right save-team-button" @click="saveTeam">Save</b-button>
  </div>
</template>

<script>
import TabItem from "../menu/tab-item";
import { VueEditor } from "vue2-editor";
import { required } from "vuelidate/lib/validators";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import moment from "moment";

var htmlEncode = require("js-htmlencode").htmlEncode;
var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  data() {
    return {
      form: {
        name: null,
        description: null,
        startDate: null,
        endDate: null
      },
      selectedSites: [],
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" }
    };
  },

  props: {
    translationalTeam: {
      type: Object
    }
  },

  watch: {
    translationalTeam: function() {
      this.form.name = this.translationalTeam.name;
      if (this.translationalTeam.description) {
        this.form.description = htmlDecode(this.translationalTeam.description);
      }

      if (this.translationalTeam.startDate) {
        this.form.startDate = this.translationalTeam.startDate;
      }

      if (this.translationalTeam.endDate) {
        this.form.endDate = this.translationalTeam.endDate;
      }

      this.selectedSites = _.map(
        this.translationalTeam.translationalTeamSites,
        function(translationalTeamSite) {
          return translationalTeamSite.site;
        }
      );
    }
  },

  validations: {
    form: {
      name: {
        required
      },
      startDate: {},
      endDate: {}
    }
  },

  components: {
    "tab-item": TabItem,
    VueEditor
  },

  computed: {
    sitesApi: function() {
      return process.env.VUE_APP_BASE_URI + "/api/Sites/FindSite?query=";
    }
  },

  methods: {
    addSite: function(selection) {
      var site = selection.selectedObject;
      // check if site has already been added
      var found = _.find(this.selectedSites, function(selectedSite) {
        return selectedSite.siteId === site.siteId;
      });
      if (!found) {
        this.selectedSites.push(site);
      }
    },

    removeSite: function(site) {
      this.selectedSites = _.reject(this.selectedSites, function(selectedSite) {
        return selectedSite.siteId === site.siteId;
      });
    },

    saveTeam: function() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        if (this.form.description) {
          this.form.description = htmlEncode(this.form.description);
        }

        this.form.translationalTeamSites = _.map(this.selectedSites, function(
          selectedSite
        ) {
          return { siteId: selectedSite.siteId };
        });

        this.$emit("save-team", this.form);
      }
    }
  }
};
</script>

<style scoped>
.site-list-div {
  margin-top: 15px;
}

.site-list {
  font-size: 16px;
}

.site-badge {
  cursor: pointer;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}

.btn-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.btn-primary:hover {
  background-color: #a02048;
}
</style>
